import React from 'react';
import { Box, Tooltip } from '../ui';
import { WarningAlertIcon } from '../Icons';

import type { ScenarioOrder } from '../../lib/planningData';
import { orderFullfillsSpecialRequirements } from '../core/Core';
import type { useSpecialRequirements } from '../hooks/useSpecialRequirements';
import type { Vessel } from '../core/Vessel';

export type SpecialRequirementsIssue = {
  orderIds: number[];
};

/** Gets special requirements warning information for a vessels-ports combination of special requirements */
export function getSpecialRequirementsWarning(
  vessel: Vessel,
  orders: ScenarioOrder[],
  specialRequirements: ReturnType<typeof useSpecialRequirements>,
  port?: { portId: number; portName: string },
) {
  const violations: string[] = [];

  for (const order of orders) {
    const fulfilledRequirements = orderFullfillsSpecialRequirements(
      vessel,
      order,
      specialRequirements,
      port,
    );

    if (!fulfilledRequirements.isFulfilled) {
      violations.push(...fulfilledRequirements.violations);
    }
  }

  return violations.length > 0 ? { violations } : undefined;
}

export const VesselSpecialRequirementsWarning = (props: {
  violations?: string[];
}) => {
  return props.violations && props.violations.length > 0 ? (
    <Tooltip
      content={
        <div>
          <strong>Special requirements violations</strong>
          <ul>
            {props.violations.map((violation) => (
              <li key={violation}>{violation}</li>
            ))}
          </ul>
        </div>
      }
    >
      <Box ml={10} width="16px" height="16px">
        <WarningAlertIcon />
      </Box>
    </Tooltip>
  ) : null;
};
